import { ButtonProps, Button as FluentButton, mergeClasses, makeStyles, tokens } from '@fluentui/react-components';
import * as React from 'react';

const useStyles = makeStyles({
  button: {
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase300,
  },
});

export const Button = ({ className, ...props }: ButtonProps) => {
  const styles = useStyles();
  return (
    <FluentButton
      {...props}
      className={mergeClasses(styles.button, className)}
    />
  );
};
